import { render, staticRenderFns } from "./bottomDetail.vue?vue&type=template&id=6b3bcd18&scoped=true&"
import script from "./bottomDetail.vue?vue&type=script&lang=js&"
export * from "./bottomDetail.vue?vue&type=script&lang=js&"
import style0 from "./bottomDetail.vue?vue&type=style&index=0&id=6b3bcd18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3bcd18",
  null
  
)

export default component.exports